import request from 'project-config/services/request/request'
import { AccountType, STORAGE, Zone } from 'project-config/constants'
import Cookie from 'project-config/utils/cookie'
import { isDev } from 'project-config/utils/env'
import { getDomainName } from 'project-config/utils/domain'
import { UserInfo } from '@/store/global/type'

export async function redirectToAuth(userInfo?: UserInfo, block = false, url = '/authenticate') {
  if (!userInfo || block) return

  if (Cookie.getCookie('rayvision_isAuthLogin')) return

  const canJump = userInfo?.zone === Zone.Domestic && userInfo.accountType === AccountType.Main

  if (!canJump) return

  const { data, code } = await request.post('/api/rendering/user/generateRealNameAuth')

  if (code === 1205) {
    // message.error(t("user_auth_certified_config_invalid"));
    return
  }

  if (code === 200) {
    const authenticateLink = isDev() ? 'http://account-pre' : 'https://account'

    const LanguageParams =
      Cookie.getCookie(STORAGE.LANGUAGE_FLAG) === '1' ? '&language=en' : '&language=zh'

    const domain = window.location.hostname.includes('127.0.0.1')
      ? 'http://127.0.0.1:3001'
      : `${authenticateLink}.${getDomainName(2)}.${getDomainName(1)}`
    const tail = `${url}?token=${data as string}${LanguageParams}`

    // To use window.open() in safari you can open another window in setTimeout.
    const link = `${domain}${tail}`
    setTimeout(() => {
      window.open(link)
    }, 0)
    // To use window.open() in safari you must put it in an element's onclick event attribute.
    // const windowReference = window.open(link)
    // if (windowReference === null) {
    //   window.location.href = link
    // }
  }
}
